const childrenLoaded = require('@alexspirgel/children-loaded');

class BlockAnchorLinks extends HTMLElement {

	constructor() {
		super();
		this._mobileBreakpoint = 768;
	}

	async connectedCallback() {
		await childrenLoaded(this);

		// Smooth scroll on link click
		for (const linkElement of this.linkElements) {
			linkElement.addEventListener('click', this.linkClickHandler);
		}

		// Mobile toggle on label click
		if (this.labelElement) {
			this.labelElement.addEventListener('click', this.toggleHandler);
		}
	}

	get labelElement() {
		return this.querySelector('.block-anchor-links__label');
	}

	get linkElements() {
		return this.querySelectorAll('.block-anchor-links__link');
	}

	get isMobile() {
		return window.innerWidth <= this._mobileBreakpoint;
	}

	toggleHandler = () => {
		if (!this.isMobile) {
			return;
		}
		const isOpen = this.classList.toggle('block-anchor-links--open');
		if (this.labelElement) {
			this.labelElement.setAttribute('aria-expanded', String(isOpen));
		}
	}

	linkClickHandler = (event) => {
		event.preventDefault();
		const linkElement = event.target;
		if (linkElement) {
			const anchorId = linkElement.getAttribute('href');
			if (anchorId) {
				history.pushState({}, '', anchorId);
				const anchorElement = document.querySelector(anchorId);
				if (anchorElement) {
					anchorElement.scrollIntoView({behavior:'smooth'});
				}
			}
		}

		// Close mobile dropdown after clicking a link
		if (this.isMobile) {
			this.classList.remove('block-anchor-links--open');
			if (this.labelElement) {
				this.labelElement.setAttribute('aria-expanded', 'false');
			}
		}

		return false;
	}

}

customElements.define('block-anchor-links', BlockAnchorLinks, {extends: 'section'});
